import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    Location,
} from 'app/Apps/ContactManagement/Locations/Locations.types'

import config from 'app/requests/Location.requests'

export default function useGetLocation(
    id,
) {
    return useRequest<Location>({
        key: RequestKeys.getLocation,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}
